'use strict';

import ngResource from 'angular-resource';

class CompanyNotifyListService {
    constructor($resource) {
        'ngInject';
        this.api = $resource(
            '/api/oem/company_notify_list/:id', { id: '@id' },
            { 
                show:   { method: 'GET', isArray: false },
                update: { method: 'PUT', isArray: false }
            }
        );
    }
}

export default angular.module('leptonApp.CompanyNotifyListService', ['ngResource'])
    .service('CompanyNotifyListService', ['$resource', CompanyNotifyListService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/company_notify_list/company_notify_list.service.js